import { Button } from "antd";
import { Fragment, useCallback, useRef } from "react";
import * as XLSX from 'xlsx';
import { CloudDownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import moment from "moment";

export default function AdminTableExport({ month, shops = [], dataSource = [] }) {
    const { t } = useTranslation()
    const tableRef = useRef(null);

    const xport = useCallback(async () => {
        const table = tableRef?.current;
        const wb = XLSX.utils.table_to_book(table);
        XLSX.writeFile(wb, `${t('revenueMultiShop', { month })}.xlsx`);
    }, [t, month]);

    return (<>
        <table ref={tableRef} style={{ display: 'none' }}>
            <tbody>
                {/* Row 1: Title */}
                <tr>
                    <td colSpan={2 + shops.reduce((sum, shop) => {
                        return sum + 1 + (shop.cabinet >= 1 ? 1 : 0) + (shop.cabinet >= 2 ? 1 : 0);
                    }, 0)}>
                        {t('revenueMultiShop', { month })}
                    </td>
                </tr>
                {/* Row 2: Shop group headers */}
                <tr>
                    <td rowSpan={2}>{t('day')}</td>
                    <td rowSpan={2}>{t('dow')}</td>
                    {shops.map(shop => {
                        const colSpan = 2 + (shop.cabinet >= 1 ? 1 : 0) + (shop.cabinet >= 2 ? 1 : 0);
                        return (
                            <td colSpan={colSpan} key={shop.shopId}>
                                {shop.shopCode}
                            </td>
                        );
                    })}
                </tr>
                {/* Row 3: Field headers per shop */}
                <tr>
                    {shops.map(shop => (
                        <Fragment key={shop.shopId}>
                            <td>{t('shop')}</td>
                            <td>{t('%wasteBoxShop')}</td>
                            {shop.cabinet >= 1 && (
                                <td>{t('cabinet', { value: 1 })}</td>
                            )}
                            {shop.cabinet >= 2 && (
                                <td>{t('cabinet', { value: 2 })}</td>
                            )}
                        </Fragment>
                    ))}
                </tr>
                {/* Data rows */}
                {dataSource.map((row, index) => (
                    <tr key={row.date}>
                        <td>{index + 1}</td>
                        <td>{t(moment(row.date).format('dddd'))}</td>
                        {shops.map(shop => (
                            <Fragment key={shop.shopId}>
                                <td>{row[`${shop.shopId}__revenue`] ?? ''}</td>
                                <td>{row[`${shop.shopId}__wasteBoxShopPercent`] != null ? `${row[`${shop.shopId}__wasteBoxShopPercent`]}%` : ''}</td>
                                {shop.cabinet >= 1 && (
                                    <td>{row[`${shop.shopId}__revenueCabinet1`] ?? ''}</td>
                                )}
                                {shop.cabinet >= 2 && (
                                    <td>{row[`${shop.shopId}__revenueCabinet2`] ?? ''}</td>
                                )}
                            </Fragment>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
        <Button type='primary' size="large" icon={<CloudDownloadOutlined />} onClick={xport}>{t('exportExcel')}</Button>
    </>);
}
